import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import LMSHeader from '../components/LMSHeader';
import useCourseStore from '../stores/useCourseStore';

const CategoryLandingPage = () => {
    const navigate = useNavigate();
    const { fetchCategories, categories: allCategories } = useCourseStore();
    const [oilAndGasCategories, setOilAndGasCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);


    const flattenCategories = useCallback((category, depth = 0) => {
        let result = [{ ...category, depth }];
        if (category.children && category.children.length > 0) {
            category.children.forEach(child => {
                result = result.concat(flattenCategories(child, depth + 1));
            });
        }
        return result;
    }, []);

    useEffect(() => {
        const fetchAndFilter = async () => {
            setIsLoading(true);
            await fetchCategories();
            setIsLoading(false);
        };

        fetchAndFilter();
    }, []);

    useEffect(() => {
        if (allCategories.length > 0) {
            const root = allCategories.find(
                cat =>
                    cat.name.toLowerCase() === 'oil and gas courses' ||
                    cat.slug === 'oil-and-gas-courses'
            );
            if (root) {
                const flat = flattenCategories(root);
                setOilAndGasCategories(flat);
            }
        }
    }, [allCategories, flattenCategories]);


    if (isLoading) {
        return (
            <><LMSHeader />
                <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex items-center justify-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
                </div>
            </>

        );
    }

    return (
        <>
            <LMSHeader />
            <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="mb-8">
                        <h1 className="text-3xl font-bold text-neutral-900 dark:text-white">Oil & Gas Courses</h1>
                        <p className="text-neutral-600 dark:text-neutral-400 mt-2">
                            Browse courses by category
                        </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {oilAndGasCategories.map(cat => (
                            <div
                                key={cat._id}
                                onClick={() => navigate(`/categories/${cat.slug}`)}
                                className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-neutral-200 dark:border-neutral-700 p-6 cursor-pointer hover:shadow-md transition-shadow"
                            >
                                <div className="flex items-start">
                                    <div className="mr-4 mt-1">
                                        <span className="text-2xl">📚</span>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-neutral-900 dark:text-white">
                                            {cat.name}
                                        </h3>
                                        <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-1">
                                            {cat.description || 'No description'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CategoryLandingPage;